"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const occupancy = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-occupancy` : '') + (description ? ` desc-occupancy` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-occupancy"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-occupancy"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 12.75C17.799 12.75 22.5 17.451 22.5 23.25C22.5 23.6642 22.1642 24 21.75 24C21.3358 24 21 23.6642 21 23.25C21 18.2794 16.9706 14.25 12 14.25C7.02944 14.25 3 18.2794 3 23.25C3 23.6642 2.66421 24 2.25 24C1.83579 24 1.5 23.6642 1.5 23.25C1.5 17.451 6.20101 12.75 12 12.75ZM12 0C15.3137 0 18 2.68629 18 6C18 9.31371 15.3137 12 12 12C8.68629 12 6 9.31371 6 6C6 2.68629 8.68629 0 12 0ZM12 1.5C9.51472 1.5 7.5 3.51472 7.5 6C7.5 8.48528 9.51472 10.5 12 10.5C14.4853 10.5 16.5 8.48528 16.5 6C16.5 3.51472 14.4853 1.5 12 1.5Z",
    fill: "inherit"
  }));
};
var _default = exports.default = occupancy;